import React, { useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import { ErrorMessage } from '../extras/toastMessages';
import { loginUserAction } from '../../actions/authActions';
import { useCurrentCenter } from '../../hooks/useCurrentCenter';


const LoginForm = () => {

    // Inicializo el centro
    const center = useCurrentCenter();

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Inicializo el history
    const history = useHistory();

    // Genero los ref
    const refPassword = useRef();
    const refUsername = useRef();

    // Inicializo el state local
    const [user, setUser] = useState({
        username: '',
        password: ''
    });

    // Manejo los cambios
    const handleChange = e => {
        setUser({
            ...user,
            [e.target.name]: e.target.value
        })
    }

    // Manejo el submit
    const handleSubmit = e => {
        e.preventDefault();
        // Valido usuario
        if(!user.username || user.username.trim() === ''){
            ErrorMessage('Debe ingresar el Usuario');
            refUsername.current.focus();
            return false;
        }
        // Valido password
        if(!user.password || user.password.trim() === ''){
            ErrorMessage('Debe ingresar la Contraseña');
            refPassword.current.focus();
            return false;
        }
        // Llamo al dispatch
        dispatch( loginUserAction(user, history) );
    }

    // Renderizo
    return (
        <>
            <div className="text-center">
                <img alt='oga' src={center?.image || '/img/logo-oga.png'} className="img-fluid" />
                <hr />
               <div className={center?.clase_centro || 'center-default'}>
                    { center?.descripcion || 'OGA' }
                </div>
                <h1 className="h4 text-gray-900 mb-4">Bienvenido!</h1>
            </div>
            <form className="user" onSubmit={handleSubmit} autoComplete="off">
                <div className="form-group">
                    <input 
                        aria-describedby="emailHelp" 
                        autoFocus
                        className="form-control form-control-user" 
                        id="exampleInputEmail" 
                        name="username"
                        onChange={handleChange}
                        placeholder="Ingrese su legajo..."
                        ref={refUsername}
                        required
                        type="text" 
                        value={user.user}
                    />
                </div>
                <div className="form-group">
                    <input 
                        className="form-control form-control-user" 
                        id="exampleInputPassword" 
                        name="password"
                        onChange={handleChange}
                        placeholder="Contraseña"
                        ref={refPassword}
                        required
                        type="password" 
                        value={user.password}
                    />
                </div>
                <Button type="submit" variant="primary" className="btn-user btn-block">
                    Iniciar sesión
                </Button>
            </form>
            <hr />
            <div className="text-center">
                <Link className="small" to="/recuperar-contrasena">
                    Olvidó su contraseña?
                </Link>
            </div>
        </>
    );
};

export default LoginForm;